import { APP_NAME, IMAGE_URL } from "../../constants/constants";

type props = {
  name?: string;
  designation?: string;
  image?: any;
  profession?: string;
};

export default function GuestCard({
  name,
  designation,
  image,
  profession,
}: props) {
  return (
    <>
      <div className="pl-1.5 pr-2.5 py-1.5 bg-[#f8f9fa] border border-solid border-[#e9ecef] items-center gap-3 flex">
        <img
          className="w-[74.25px] h-[93px]"
          src={IMAGE_URL + image}
          alt={APP_NAME}
        />
        <div className="flex-col justify-start items-start gap-1.5 inline-flex">
          <div className="self-stretch text-[#f28e72] text-xs font-bold font-['Encode Sans Condensed'] uppercase leading-snug tracking-wide">
            Speakers
          </div>
          <div className="self-stretch h-[50px] flex-col justify-start items-start gap-1 flex">
            <div className="text-[#212529] text-base font-semibold font-['Encode Sans Condensed'] leading-normal">
              {name || "N/A"}
            </div>
            <div className="text-[#6c757d] text-[13px] font-normal font-['Encode Sans Condensed'] leading-snug tracking-wide">
              {profession || "N/A"}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
